export default __webpack_public_path__ + "static/media/FOTO4.27f69f81.png";